"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactChartjs = require("react-chartjs-2");
var _chart = require("chart.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // First, make sure you have installed the necessary dependencies:
// npm install d3 react react-dom
// Create a new React component for the stacked area chart
_chart.Chart.register(_chart.CategoryScale, _chart.LinearScale, _chart.PointElement, _chart.LineElement, _chart.Title, _chart.Tooltip, _chart.Filler, _chart.Legend);
let containerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
let inputStyling = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "1%"
};
const StreamGraph = _ref => {
  let {
    data,
    overallStyle
  } = _ref;
  const [topping, setTopping] = (0, _react.useState)("StackOffsetNone");
  const onOptionChange = e => {
    setTopping(e.target.value);
  };
  const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top"
      }
    },
    animations: {
      tension: {
        duration: 1000,
        easing: "linear",
        from: 1,
        to: 0,
        loop: true
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: inputStyling
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: inputStyling
  }, /*#__PURE__*/_react.default.createElement("select", {
    value: topping,
    onChange: onOptionChange
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: "StackOffsetNone"
  }, "StackOffsetNone"), /*#__PURE__*/_react.default.createElement("option", {
    value: "StackOffsetExpand"
  }, "StackOffsetExpand"), /*#__PURE__*/_react.default.createElement("option", {
    value: "StackOffsetSilhouette"
  }, "StackOffsetSilhouette"), /*#__PURE__*/_react.default.createElement("option", {
    value: "StackOffsetWiggle"
  }, "StackOffsetWiggle"))), /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({}, containerStyle), overallStyle)
  }, /*#__PURE__*/_react.default.createElement(_reactChartjs.Line, {
    options: graphOptions,
    data: data[topping],
    style: overallStyle
  })));
};
var _default = exports.default = StreamGraph;